<template>
  <div :style="wrapStyle">
    <svg :width="big ? 22 : 18" :height="big ? 22 : 18" viewBox="0 0 24 24" fill="none">
      <path d="M3 12c0-5 4-9 9-9s9 4 9 9-4 9-9 9" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>
      <circle cx="12" cy="12" r="3" fill="#fff"/>
    </svg>
    <span>Sicamex</span>
    <span v-if="companyName" :style="subStyle">| {{ companyName }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size:        { type: String, default: 'md' },
  companyName: { type: String, default: '' },
})

const big = computed(() => props.size === 'lg')

const wrapStyle = computed(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
  padding: big.value ? '12px 18px' : '8px 12px',
  background: 'var(--primary)',
  borderRadius: '6px',
  fontFamily: 'var(--ff-head)',
  color: '#fff',
  fontWeight: 700,
  fontSize: big.value ? '18px' : '15px',
  letterSpacing: '0.2px',
}))

const subStyle = computed(() => ({
  opacity: 0.6,
  fontWeight: 500,
  fontSize: big.value ? '16px' : '13px',
}))
</script>
